// We only need to import the modules necessary for initial render
import CoreLayout from './Static/Page/index'

import Home from './Module/Home/index'
import Gestion from './Module/Gestion/index'
import CRM from './Module/CRM/index'
import Configuration from './Module/Configuration/index'
import Documentation from './Module/Documentation/index'
import Compte from './Page/Compte/Page/CompteView'
import Restaurant from './Module/Restaurant/index'
import Menu from './Module/Menu/index'
import SDD from './Module/SDD/index'
import Fidelite from './Module/Fidelite/index'
import Pedagogie from './Module/Pedagogie/index'
import Page from './Module/Page/index'
import Stock from './Module/Stock/index'
import Media from './Module/Media/index'
import Api from './Module/Api/index'
import AllianceReseaux from './Module/AllianceReseaux/index'
import Hotel from './Module/Hotel/index'

const routes = [{
  path: 'crm',
  component: CRM
}, {
  path: 'gestion',
  component: Gestion
}, {
  path: 'configuration',
  component: Configuration
}, {
  path: 'documentation',
  component: Documentation
}, {
  path: 'compte',
  component: Compte
}, {
  path: 'restaurant',
  component: Restaurant
}, {
  path: 'menu',
  component: Menu
}, {
  path: 'sdd',
  component: SDD
}, {
  path: 'fidelite',
  component: Fidelite
}, {
  path: 'pedagogie',
  component: Pedagogie
}, {
  path: 'stock',
  component: Stock
}, {
  path: 'media',
  component: Media
}, {
  path: 'requete-api',
  component: Api
}, {
  path: 'alliance_reseaux',
  component: AllianceReseaux
}, {
  path: 'hotel',
  component: Hotel
}]


/*  Note: Instead of using JSX, we recommend using react-router
 PlainRoute objects to build route definitions.   */

export const createRoutes = _ => {
  return [
    {
      path: '/',
      component: CoreLayout,
      indexRoute: { component: Home }
    },
    {
      path: `/page`,
      component: Page,
      indexRoute: { component: Page },
      childRoutes: [
        {
          path: `/page`,
          component: Page
        }, {
          path: `/page/:page`,
          component: Page
        },
        {
          path: `/page/:page/:page`,
          component: Page
        },
        {
          path: `/page/:page/:page/:page`,
          component: Page
        },
        {
          path: `/page/:page/:page/:page/:page`,
          component: Page
        }
      ],
    },
    ...routes.map(route => {
      return {
        path: `/${route.path}`,
        component: CoreLayout,
        indexRoute: { component: route.component },
        childRoutes: [{
          path: `/${route.path}/:page`,
          component: route.component
        }, {
          path: `/${route.path}/:page/:page`,
          component: route.component
        }, {
          path: `/${route.path}/:page/:page/:page`,
          component: route.component
        }, {
          path: `/${route.path}/:page/:page/:page/:page`,
          component: route.component
        }
        ]
      }
    })
  ]
}

export default createRoutes



// WEBPACK FOOTER //
// ./app/App/index.js